import type { WaitMusic } from 'lib-shared-types-api';

export function transformWaitMusic(
  waitMusic: Omit<WaitMusic, 'id'> & { id?: string; uuid?: string },
): WaitMusic {
  waitMusic.id = waitMusic.uuid;
  delete waitMusic.uuid;
  return waitMusic as WaitMusic;
}
